const Christmas = () => {

    const burgerChristmas = document.getElementsByClassName('lp-christmas__menu-burger')[0];
    const burgerChristmasWrapper = document.getElementsByClassName('lp-christmas__menu-burger-wrapper')[0];
    const burgerChristmasLinks   = document.getElementsByClassName('lp-christmas__menu-burger-wrapper-list-item');

    if(burgerChristmasLinks) {
        for(var i = 0; i < burgerChristmasLinks.length; i++) {
            burgerChristmasLinks[i].addEventListener('click', function() {
                if(burgerChristmasWrapper) {
                    burgerChristmasWrapper.classList.remove('active');
                }
                if(burgerChristmas) {
                    burgerChristmas.classList.remove('opened');
                }
            })
        }
    }


    if(burgerChristmas) {
        burgerChristmas.addEventListener('click', function() {

            if(this.classList.contains('opened')) {
                this.classList.remove('opened');
                burgerChristmasWrapper.classList.remove('active');
            } else {
                this.classList.add('opened');
                burgerChristmasWrapper.classList.add('active');
            }

        })
    }


    const burgerglobal = document.getElementsByClassName('lp-global-header__menu-burger')[0];
    const burgerglobalWrapper = document.getElementsByClassName('lp-global-header__menu-burger-wrapper')[0];
    const burgerglobalLinks   = document.getElementsByClassName('lp-global-header__menu-burger-wrapper-list-item');

    if(burgerglobalLinks) {
        for(var i = 0; i < burgerglobalLinks.length; i++) {
            burgerglobalLinks[i].addEventListener('click', function() {
                if(burgerglobalWrapper) {
                    burgerglobalWrapper.classList.remove('active');
                }
                if(burgerglobal) {
                    burgerglobal.classList.remove('opened');
                }
            })
        }
    }


    if(burgerglobal) {
        burgerglobal.addEventListener('click', function() {

            if(this.classList.contains('opened')) {
                this.classList.remove('opened');
                burgerglobalWrapper.classList.remove('active');
            } else {
                this.classList.add('opened');
                burgerglobalWrapper.classList.add('active');
            }

        })
    }



}

export default Christmas;